import { useAuth } from '@clerk/clerk-react'
import { useMemo } from 'react'

import { createRouteClient, type osRoutes } from '@snootsvet/shared'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api/os'

/** Typed client for the staff API routes in `osRoutes`. */
export function useOsApi() {
  const { getToken } = useAuth()
  return useMemo(
    () =>
      createRouteClient<typeof osRoutes>({
        baseUrl: API_BASE_URL,
        credentials: 'include',
        headers: async (): Promise<Record<string, string>> => {
          const token = await getToken()
          return token ? { Authorization: `Bearer ${token}` } : {}
        },
      }),
    [getToken]
  )
}
